import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanCalendarRoute: InvariantJiraRoute = {
	name: 'software-plan-calendar',
	path: '/jira/plans/:planId/scenarios/:scenarioId/calendar',
};
